// chipArrayReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chipData: [], // Default value
};

const chipArraySlice = createSlice({
  name: 'chipArray',
  initialState,
  reducers: {
    setChipData(state, action) {
      state.chipData = action.payload; // Update the chip data
    },
    reset4ChipArray() {
      return initialState; // Reset to initial state
    },
  },
});

export const { setChipData, reset4ChipArray } = chipArraySlice.actions;

export default chipArraySlice.reducer;
// const initialState = {
//   chipData: [], // Default value
// };

// export default function chipArrayReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setChipData':
//       return {
//         ...state,
//         chipData: action.payload, // Update the selected book
//       };
//     case 'reset4ChipArray':
//       return initialState;     
//     default:
//       return state;
//   }
// }

// export const setChipData = (e) => ({
//   type: 'setChipData',
//   payload: e,
// });

// export const reset4ChipArray  = (e) => ({
//   type: 'reset4ChipArray',
//   payload: e,
// });